package org.example.project.screens_shared

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.example.project.enginekalender.KalenderAufgabenCalendar
import org.example.project.enginekalender.kalenderTodayIsoDate
import org.example.project.service.LoginService
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun SHAREDAufgabenverwaltung(art: String, node: String) {
    val user = LoginService.getUser()
    val userId = user?.id.orEmpty()
    val firmaId = user?.firmenId.orEmpty()
    val contextKey = "$art#$node#$userId#$firmaId"
    var selectedDate by remember(contextKey) { mutableStateOf(kalenderTodayIsoDate()) }
    var view by remember(contextKey) { mutableStateOf("Monat") }
    var monthDayOpen by remember(contextKey) { mutableStateOf(false) }
    var copyKind by remember(contextKey) { mutableStateOf("") }
    var copySource by remember(contextKey) { mutableStateOf("") }
    var copyRequestToken by remember(contextKey) { mutableStateOf(0) }

    val name = listOf(user?.vorname.orEmpty(), user?.nachname.orEmpty())
        .filter(String::isNotBlank).joinToString(" ")
        .ifBlank { user?.name.orEmpty().ifBlank { userId.ifBlank { "Meine Aufgaben" } } }
    val actions = buildList {
        add(All(key = "mark-day", label = "Tag markieren"))
        add(All(key = "mark-week", label = "Woche markieren"))
        if (copyKind.isNotBlank()) add(All(key = "task-copy", label = "Kopieren auf"))
    }

    Div({ style {
        width(100.percent); height(100.percent); display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column); justifyContent(JustifyContent.FlexStart)
        alignItems(AlignItems.FlexStart); padding(12.px, 10.px, 16.px, 10.px)
        boxSizing("border-box"); gap(10.px)
    } }) {
        KalenderDesktopNavigation(
            name = name,
            firma = user?.firma.orEmpty().ifBlank { user?.kunde.orEmpty().ifBlank { "Keine Firma hinterlegt" } },
            position = user?.position.orEmpty().ifBlank { "Keine Position hinterlegt" },
            selectedDate = selectedDate,
            onSelectDate = { selectedDate = it; monthDayOpen = false },
            showTaskSwitch = false,
            taskMode = true,
            onTaskModeChange = {},
            view = view,
            onViewChange = { view = it; monthDayOpen = false },
            showSettings = userId.isNotBlank(),
            settingsPlaceholder = "Aufgaben kopieren",
            settingsOptions = actions,
            onSettingsAction = { action ->
                when (action) {
                    "mark-day", "mark-week" -> {
                        val kind = if (action == "mark-day") "Tag" else "Woche"
                        copyKind = if (copyKind == kind) "" else kind
                        copySource = selectedDate
                    }
                    "task-copy" -> copyRequestToken += 1
                }
            }
        )
        Div({ style {
            width(100.percent); flexGrow(1); minHeight(0.px); minWidth(0.px)
            display(DisplayStyle.Flex); overflow("hidden"); boxSizing("border-box")
            padding(0.px, 6.px)
        } }) {
            KalenderAufgabenCalendar(
                selectedDate = selectedDate,
                onSelectDate = { selectedDate = it },
                art = art,
                kalenderUserId = userId,
                kalenderFirmenId = firmaId,
                ansicht = view,
                monthDayOpen = monthDayOpen,
                onMonthDayOpen = { monthDayOpen = it },
                copyKind = copyKind,
                copySource = copySource,
                copyRequestToken = copyRequestToken,
                onCopyComplete = { copyKind = "" },
                editMode = true
            )
        }
    }
}
